import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">
            SafeTec<span className="text-blue-600">+</span>
          </Link>
          <Link to="/">
            <Button variant="outline" size="sm">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Zurück
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>

        <div className="prose prose-gray max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>HS Hanse Trade KG</strong><br />
              Oldachstrasse 32<br />
              22307 Hamburg
            </p>
            <p className="text-gray-700 leading-relaxed">
              Vertretungsberechtigter Gesellschafter: Sebastian Cornelius Schaper (Komplementär)
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Kontakt</h2>
            <p className="text-gray-700 leading-relaxed">
              Telefon: +49 174 2619596<br />
              E-Mail: anfrage@safetec-plus.de
            </p>
          </section>

          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed mb-2">
              <strong>Registergericht:</strong> Hamburg<br />
              <strong>Registernummer:</strong> HRA124076
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</strong> DE322181401
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Information nach dem Verbraucherstreitbeilegungsgesetz</h2>
            <p className="text-gray-700 leading-relaxed">
              Es besteht keine Verpflichtung und keine Bereitschaft zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Verweise und Links – Distanzierungserklärung</h2>
            <p className="text-gray-700 leading-relaxed">
              Bei direkten oder indirekten Verweisen auf fremde Internetseiten („Links"), die außerhalb des Verantwortungsbereiches des Diensteanbieters liegt, haftet dieser nur dann, wenn er von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Diensteanbieter erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung die entsprechenden verlinkten Seiten frei von illegalen Inhalten waren. Der Diensteanbieter erklärt weiterhin, dass er keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der gelinkten / verknüpften Seiten hat. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller gelinkten / verknüpften Seiten, die nach der Linksetzung verändert wurden. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/">
            <Button className="bg-blue-600 hover:bg-blue-700">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>

      {/* Simple Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 SafeTec+ | HS Hanse Trade KG | Hamburg
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;
